module.exports = __webpack_public_path__ + "img/unsplash-02.cea0580d.jpg";